import React from "react";
import { createPortal } from "react-dom";
import { getCssVar, themeColors } from "../utils/theme";
import styles from "./RestBanner.module.css";

/**
 * Banner fixo no topo da tela durante o período de descanso entre exercícios.
 * Usa inline styles para ser independente de CSS modules.
 */
export default function RestBanner({ seconds, exerciseName, onDone }) {
  const endRef = React.useRef(Date.now() + seconds * 1000);
  const [remaining, setRemaining] = React.useState(seconds);
  const onDoneRef = React.useRef(onDone);
  React.useEffect(() => { onDoneRef.current = onDone; });

  React.useEffect(() => {
    const tick = () => {
      const r = Math.ceil((endRef.current - Date.now()) / 1000);
      if (r <= 0) { setRemaining(0); onDoneRef.current(); return; }
      setRemaining(r);
      t = setTimeout(tick, 250);
    };
    let t = setTimeout(tick, 250);
    // visibilitychange sozinho nao e confiavel em PWA standalone no iOS (o
    // WebKit as vezes nao dispara ao voltar de outro app/tela bloqueada) -
    // focus/pageshow servem de segunda rede de seguranca pro mesmo recalculo.
    const onVisible = () => { if (!document.hidden) { clearTimeout(t); tick(); } };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    window.addEventListener("pageshow", onVisible);
    return () => {
      clearTimeout(t);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
      window.removeEventListener("pageshow", onVisible);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const pct     = Math.round(((seconds - remaining) / seconds) * 100);
  const mins    = Math.floor(remaining / 60);
  const secs    = remaining % 60;
  const timeStr = mins > 0 ? `${mins}:${String(secs).padStart(2, "0")}` : `${remaining}s`;

  const accentRgb = getCssVar("--accent-rgb", "29, 158, 117");
  const blue      = themeColors.blue;
  const blueOn    = getCssVar("--blue-on", "var(--text-primary)");

  return createPortal(
    <div className={styles.banner} style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 2000,
      background: "linear-gradient(135deg, var(--surface-0-98), var(--surface-26-85))",
      borderBottom: `1px solid rgba(${accentRgb},0.35)`,
      boxShadow: "0 4px 24px rgba(0,0,0,0.5)",
      padding: "10px 16px 6px",
      display: "flex", flexDirection: "column", gap: 6,
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ fontSize: 11, color: `rgba(${accentRgb},0.7)`, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase" }}>
            ⏱ Descanso - {exerciseName}
          </span>
          <span style={{ fontSize: 28, fontWeight: 800, color: blue, lineHeight: 1.1, fontVariantNumeric: "tabular-nums" }}>
            {timeStr}
          </span>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); onDoneRef.current(); }}
          style={{
            background: `rgba(${accentRgb},0.18)`, border: `1px solid rgba(${accentRgb},0.4)`,
            borderRadius: 10, color: blueOn, fontSize: 13, fontWeight: 600,
            padding: "8px 16px", cursor: "pointer",
            backgroundColor: blue,
          }}
        >
          Pular ▶
        </button>
      </div>
      <div style={{ height: 4, background: "rgba(255,255,255,0.08)", borderRadius: 2, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${pct}%`, background: blue, borderRadius: 2, transition: "width 0.25s linear" }} />
      </div>
    </div>,
    document.body
  );
}
